module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/button-inset-outline-border/button-inset-outline-border.component.scss
// module id = ./src/app/features/buttons/button-inset-outline-border/button-inset-outline-border.component.scss
// module chunks = main